import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
} from '@angular/core';

@Component({
  standalone: true,
  selector: 'fl-progress-substep',
  template: `
    <div class="text-body-16 font-normal text-foreground">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./progress-substep.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressSubstepComponent {
  elementRef = inject(ElementRef);
}
